<ion-header *ngIf="!isNotFound" no-border class="header">
  <ion-img
    *ngIf="isScreenSaver ? !config?.screenSaver?.hideLogo : true"
    (tap)="press()"
    src="{{ config.logo }}"
    class="header--logo"
  ></ion-img>
</ion-header>
